import Usuario from "model/administracao/cadastro/Usuario";

export default class AdicionarRevisao {
    idDocumento: number;
    responsavelAprovacao: Usuario | null;
    prazoAprovacao: Date | null;
    responsavelRevisao: Usuario | null;
    prazoRevisao: Date | null;
	observacaoParaRevisao : string;
    constructor(
        idDocumento = 0,
        responsavelAprovacao: Usuario | null = null,
        prazoAprovacao = new Date(),
        responsavelRevisao: Usuario | null = null,
        prazoRevisao = new Date(),
        observacaoParaRevisao = ''
    ) {
        this.idDocumento = idDocumento;
        this.responsavelAprovacao = responsavelAprovacao;
        this.prazoAprovacao = prazoAprovacao;
        this.responsavelRevisao = responsavelRevisao;
        this.prazoRevisao = prazoRevisao;
        this.observacaoParaRevisao = observacaoParaRevisao;
    }
}